import { useState, useRef } from "react";
import classNames from "classnames";
import { useProductsLiked, useLikeProduct, useCurrentUser } from "@hooks/use-current-user";
import Offcanvas from "@components/core/Offcanvas";
import MenuListDropdown from "@components/core/MenuListDropdown";
import { useOpenAuthOffcanvasPriorToLikeProduct } from "@hooks/use-userlists";
import LikeButton from "./LikeButton";
import MenuWishlistProductEdit from "./MenuWishlistProductEdit";
import MenuUserListProductEdit from "./MenuUserListProductEdit";

const ProductLike = ({ product, className, isOnUserList, onProductRemovedFromUserList }) => {
  const user = useCurrentUser();
  const productsLiked = useProductsLiked();
  const likeProduct = useLikeProduct();
  const openAuthOffcanvasPriorToLikeProduct = useOpenAuthOffcanvasPriorToLikeProduct();

  const [dropdownAddToUserListOpened, setDropdownAddToUserListOpened] = useState(false);
  const [offcanvasAddToUserListOpened, setOffcanvasAddToUserListOpened] = useState(false);

  const menuListDropdownRef = useRef();

  const productId = product?.id;
  const liked = productsLiked?.includes(Number(productId));

  function addMenuListDropdownEventListener() {
    const handleClickOutside = (event) => {
      if (menuListDropdownRef?.current && !menuListDropdownRef?.current?.contains(event.target)) {
        closeDropdownAddToUserList();
        document.removeEventListener("mousedown", handleClickOutside);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
  }

  function toggleLike(deviceSize) {
    if (!user) {
      return openAuthOffcanvasPriorToLikeProduct(product);
    }

    if (!liked) {
      return likeProduct(product);
    }

    switch (deviceSize) {
      case "mobile":
        setOffcanvasAddToUserListOpened(true);
        break;
      case "desktop":
        addMenuListDropdownEventListener();
        setDropdownAddToUserListOpened(true);
        break;
      default:
        return null;
    }
  }

  function closeDropdownAddToUserList() {
    setDropdownAddToUserListOpened(false);
  }

  function closeOffcanvasAddToUserList() {
    setOffcanvasAddToUserListOpened(false);
  }

  function onProductRemovedFromUserListAndClose() {
    onProductRemovedFromUserList();
    closeDropdownAddToUserList();
    closeOffcanvasAddToUserList();
  }

  if (!productId) return null;

  return (
    <div className={classNames("product-like-container", className)}>
      <div className={classNames("product-like-content")}>
        <LikeButton
          liked={liked}
          onClick={() => toggleLike("mobile")}
          className="d-md-none"
        />

        <LikeButton
          liked={liked}
          onClick={() => toggleLike("desktop")}
          className="d-none d-md-block"
        />

        <MenuListDropdown
          ref={menuListDropdownRef}
          show={dropdownAddToUserListOpened}
          className="pt-1 product-like-menu-list-dropdown"
        >
          {isOnUserList ? (
            <MenuUserListProductEdit
              product={product}
              onActionEnd={onProductRemovedFromUserListAndClose}
            />
          ) : (
            <MenuWishlistProductEdit
              product={product}
              onActionEnd={closeDropdownAddToUserList}
            />
          )}
        </MenuListDropdown>

        <Offcanvas
          show={offcanvasAddToUserListOpened}
          onHide={closeOffcanvasAddToUserList}
          placement="bottom"
          title="Modifier"
        >
          <div className="pb-5">
            {isOnUserList ? (
              <MenuUserListProductEdit
                product={product}
                onActionEnd={onProductRemovedFromUserListAndClose}
              />
            ) : (
              <MenuWishlistProductEdit
                product={product}
                onActionEnd={closeOffcanvasAddToUserList}
              />
            )}
          </div>
        </Offcanvas>
      </div>
    </div>
  );
};

export default ProductLike;
